'use strict';
import adModal from './app-switch.model.html';

const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './app-switch.routes';

export class AppSwitchComponent {
    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
    }

    $onInit() {
        this.totalCount = 0;
        this.search();
    }

    search() {
        this.$http.get('/api/utills/app-switchs', {
            params: this.filters
        })
            .then(response => {
                if(response.data.data) {
                    this.adDefaults = response.data.data;
                    this.totalCount = response.data.data.length;
                }
            });
    }


    createOne() {
        const that = this;
        this.$uibModal.open({
            template: adModal,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.vm = {};
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/utills/app-switchs', $scope.vm).then(response => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };
            }
        });
    }

    delete(ad) {
        this.$http.delete(`/api/utills/app-switchs/${ad.id}`)
            .then(response => {
                this.$onInit();
            });
    }

    edit(ad) {
        const that = this;
        this.$uibModal.open({
            template: adModal,
            size: 'lg',
            /*@ngInject*/
            controller($scope, $http, $uibModalInstance) {
                $scope.vm = ad;
                $scope.cancel = function() {
                    $uibModalInstance.close();
                };

                $scope.save = function(myForm) {
                    if(myForm.$valid === false) {
                        return false;
                    } else {
                        $http.post('/api/utills/app-switchs', $scope.vm).then(response => {
                            that.$onInit();
                            $uibModalInstance.close();
                        }, error => {
                            console.log(error);
                        });
                    }
                };
            }
        });
    }
}

export default angular.module('tttApp.app-switch', [uiRouter])
    .config(routes)
    .component('appSwitch', {
        template: require('./app-switch.html'),
        controller: AppSwitchComponent,
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/app-switch/app-switch.component.js